import { useEffect, useState } from 'react';
import { useAuth } from '../hooks';
import styles from '../styles/navbar.module.css';
import { Link } from 'react-router-dom';
import { searchUsers } from '../api';
const Navbar = () => {
    const [result, setResult] = useState([]);
    const [searchText, setSearchText] = useState('');
    const auth = useAuth();
    useEffect(() => {
        const fetchUsers = async () => {
            const response = await searchUsers(searchText);
            if (response.success) {
                setResult(response.data.users);
            }
        }
        if (searchText.length > 2) {
            fetchUsers();
        } else {
            setResult([]);
        }
    }, [searchText]);

    const handleSearchUserClick = () => {
        setSearchText('');
    }
    return (
        <div className={styles.nav}>
            <div className={styles.leftDiv}>
                <Link to="/">
                    <img src="https://cdn-icons-png.flaticon.com/128/8112/8112719.png" alt="Logo" height={50} />
                </Link>
            </div>

            {auth.user && <div className={styles.searchContainer}>
                <img src="https://cdn-icons-png.flaticon.com/128/622/622669.png" alt="search" className={styles.searchIcon} />
                <input type="text" className={styles.searchInput} placeholder="Search User" value={searchText} onChange={(e) => { setSearchText(e.target.value) }} />
                {result.length > 0 && <div className={styles.searchResults}>
                    <ul>
                        {result.map((user) => (
                            <Link to={`/user/${user._id}`} onClick={handleSearchUserClick}>
                                <li key={`user-${user._id}`} className={styles.searchResultsRow}>
                                    <img src="https://cdn-icons-png.flaticon.com/128/3135/3135715.png" alt="user" className={styles.dp} />
                                    <span>{user.name}</span>
                                </li>
                            </Link>
                        ))}
                    </ul>
                </div>}
            </div>}
            <div className={styles.rightNav}>
                {auth.user && <div className={styles.user}>
                    <Link to="/settings">
                        <img alt="user" src="https://cdn-icons-png.flaticon.com/128/2202/2202112.png" className={styles.userDp} />
                    </Link>
                    <span>{auth.user.name}</span>
                </div>}

                <div className={styles.navLinks}>
                    <ul>
                        {auth.user ?
                            (<>
                                <li onClick={auth.logout}>
                                    Log out
                                </li>
                            </>) : (<>
                                <li>
                                    <Link to="/login">Log in</Link>
                                </li>

                                <li>
                                    <Link to="/register">Register</Link>
                                </li>
                            </>)}

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Navbar;